import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import background from '../../assets/background1.jpeg';

const GiftSection: React.FC = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const langPrefix = i18n.language === 'it' ? '/it' : '/eng';

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <section
      id="gifts"
      className="w-full flex flex-col items-center"
      style={{
        backgroundImage: `url(${background})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
      }}
    >
      <div className="w-full max-w-2xl mx-auto flex flex-col items-center text-center font-body px-6 py-16">
        {/* Title */}
        <h1 className="font-cursive text-4xl font-bold mb-4 tracking-wide">{t('gifts')}</h1>

        {/* Subtitle */}
        <p className="text-lg mb-2">{t('gifts_subtitle')}</p>

        {/* Description */}
        <p className="text-lg max-w-md mb-10">
          {t('gifts_description')}
        </p>

        {/* Divider */}
        <div className="w-24 border-t border-[#2d5a2d]/40 mb-10"></div>

        {/* Payment options */}
        <div className="flex flex-col gap-6 w-full max-w-sm">
          <div className="relative" ref={dropdownRef}>
            <button
              onClick={() => setDropdownOpen(!dropdownOpen)}
              className="gift-btn w-full flex items-center justify-center gap-3 bg-[#2d5a2d] px-6 py-4 rounded-lg hover:bg-[#245024] transition-colors duration-300 shadow-md cursor-pointer"
            >
              <span className="font-medium text-lg">{t('contribute_credit_card')}</span>
            </button>

            {dropdownOpen && (
              <div className="absolute left-0 right-0 mt-3 bg-white/90 backdrop-blur-sm rounded-lg shadow-lg border border-[#2d5a2d]/20 z-20 overflow-hidden">
                <button
                  onClick={() => { setDropdownOpen(false); navigate(`${langPrefix}/euro${location.search}`); }}
                  className="w-full flex items-center gap-3 px-5 py-4 hover:bg-[#2d5a2d]/5 transition-colors text-[#2d5a2d] text-base font-medium cursor-pointer"
                >
                  <span className="w-8 h-8 rounded-full bg-[#2d5a2d]/10 flex items-center justify-center text-lg font-bold text-[#2d5a2d]">€</span>
                  Euro
                </button>
                <div className="border-t border-[#2d5a2d]/10 mx-4"></div>
                <button
                  onClick={() => { setDropdownOpen(false); navigate(`${langPrefix}/shekel${location.search}`); }}
                  className="w-full flex items-center gap-3 px-5 py-4 hover:bg-[#2d5a2d]/5 transition-colors text-[#2d5a2d] text-base font-medium cursor-pointer"
                >
                  <span className="w-8 h-8 rounded-full bg-[#2d5a2d]/10 flex items-center justify-center text-lg font-bold text-[#2d5a2d]">₪</span>
                  Shekel
                </button>
              </div>
            )}
          </div>
        </div>

        {/* Thank you */}
        <p className="font-cursive text-2xl mt-16 mb-6">{t('thank_you')}</p>
      </div>
    </section>
  );
};

export default GiftSection;
